import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
import { ConditionsChoiceOptionUI } from './ConditionsChoiceOptionUI';
import { ConditionsChoiceOption } from './ConditionsChoiceOption';
export class ConditionsChoice extends ConditionRegistryCategory {
    label = 'Choice';
    c_optionUI = new ConditionsChoiceOptionUI(this);
    c_option = new ConditionsChoiceOption(this);
}
